var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment } from '@mui/material';
import { MagnifyingGlass } from '../../assets';
import InputBase from '../InputBase';
var SearchInput = function (props) {
    var onChange = props.onChange, _a = props.placeholder, placeholder = _a === void 0 ? 'Search' : _a;
    return (_jsx(InputBase, { fullWidth: true, type: "text", onChange: onChange, placeholder: placeholder, value: "", startAdornment: _jsx(InputAdornment, __assign({ position: "start" }, { children: _jsx(MagnifyingGlass, {}) })) }));
};
export default SearchInput;
